import styled from '@emotion/styled';
import { Modal } from '@ui-components/neo.tax';

// The dialog panel stretches to the viewport unless it is constrained, which leaves a confirmation
// this short spanning the whole page. 540px matches the other confirm-and-cancel modals.
export const StyledModal = styled(Modal)({
  maxWidth: '540px',
  width: '100%',
});
